import { createValidation } from '_metronic/helpers'
import { TFunction } from '_metronic/i18n/Metronici18n'
import * as Yup from 'yup'

export const modeloVinculosSchema = (t: TFunction) => {
  const v = createValidation(t)

  return Yup.object().shape({
    cids: Yup.array().of(Yup.object()).min(1, v.requiredField('cid', 'array')),
    medicamentos: Yup.array().of(Yup.object()).min(1, v.requiredField('medicamento', 'array')),
  })
}
